import Vue from 'vue'
import Router from 'vue-router'
import Fruit from '../components/Fruit'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('@/components/AppIntro'),
        },
        {
            path: '/fruit',
            name: 'Fruit',
            component: Fruit
        },
        {
            path: '/intro',
            name: 'AppIntro',
            component: () => import('@/components/AppIntro'),
        }
    ]
})
